import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger, useGSAP);

function AnimationAaaaah({ containerClassName }) {
    const containerClasses = (containerClassName) ? `animation--aaaaah ${containerClassName} nostroke-scale` : 'animation--aaaaah nostroke-scale';

    // Au montange du composant on regarde la taille de l'écran et on charge un composant
    // en fonction
    let [svgChildren, setSvgChildren] = useState(<AaaaahDesktop containerClasses={containerClasses} />);

    // On définit la fonction qui va permet de réaliser le switch
    const setAnimationAnimationAaaaah = useCallback(() => {
        if(window.innerWidth <= 600) {
            setSvgChildren(<AaaaahMobile containerClasses={containerClasses} />);
        } else {
            setSvgChildren(<AaaaahDesktop containerClasses={containerClasses} />);
        }
    }, [containerClasses]);

    // On bind l'appel de la fonction au resize
    useEffect(() => {
        setAnimationAnimationAaaaah();
        window.addEventListener('resize', setAnimationAnimationAaaaah, true);

        // On pense bien à unbind l'écouteur lors du démontage du composant
        return () => {
            window.removeEventListener('resize', setAnimationAnimationAaaaah, true);
        };
    }, [containerClasses, setAnimationAnimationAaaaah]);

    return svgChildren;
}

AnimationAaaaah.propTypes = {
    id: PropTypes.string.isRequired,
    containerClassName: PropTypes.string,
}

export default AnimationAaaaah;

function AaaaahDesktop({ containerClasses }) {
    // On définit les références du SVG
    const svgRefDesktop = useRef(null);
    const ligne1Ref = useRef(null);
    const ligne2Ref = useRef(null);
    const ligne3Ref = useRef(null);
    const ligne4Ref = useRef(null);
    const ligne5Ref = useRef(null);
    const ligne6Ref = useRef(null);

    // On initialise le hook de GSAP pour React afin de gérer l'ajout et la suppression des
    // écouteurs de manière automatique
    useGSAP(() => {
        if(!svgRefDesktop || !ligne1Ref || !ligne2Ref || !ligne3Ref || !ligne4Ref || !ligne5Ref || !ligne6Ref) return;

        // On liste les lignes à animer dans un tableau
        const lines = [
            { selector: "#Aaaaaah_desktop #Ligne_1", x: 250, endTrigger: ligne1Ref.current },
            { selector: "#Aaaaaah_desktop #Ligne_2", x: -250, endTrigger: ligne2Ref.current },
            { selector: "#Aaaaaah_desktop #Ligne_3", x: 250, endTrigger: ligne3Ref.current },
            { selector: "#Aaaaaah_desktop #Ligne_4", x: -250, endTrigger: ligne4Ref.current },
            { selector: "#Aaaaaah_desktop #Ligne_5", x: 250, endTrigger: ligne3Ref.current },
            { selector: "#Aaaaaah_desktop #Ligne_6", x: -250, endTrigger: ligne4Ref.current }
        ]

        // On définit l'animation ligne par ligne
        lines.forEach((line) => {
            gsap.to(line.selector, {
                x: line.x,
                ease: 'none',
                scrollTrigger: {
                    trigger: line.selector,
                    start: "top bottom",
                    endTrigger: line.endTrigger,
                    end: "bottom top",
                    scrub: true
                },
            });
        })
    }, { scope: svgRefDesktop });

    return (
        <svg role="img" ref={svgRefDesktop} id="Aaaaaah_desktop" className={containerClasses} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 2200 860.1">
            <title>Aaaaaaaaaaaaaahhh</title>
            <g ref={ligne1Ref} id="Ligne_1" className="svg--isolate">
                <text className="svg--primary" transform="translate(-1038.1 151)"><tspan x="0" y="0">aaaaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne2Ref} id="Ligne_2" className="svg--isolate">
                <text className="svg--isolate" transform="translate(-1083.3 289.6)"><tspan x="0" y="0">aaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne3Ref} id="Ligne_3" className="svg--isolate">
                <text className="svg--primary" transform="translate(-834.2 428.2)"><tspan x="0" y="0">aaaaaaaaaaaaaahhhhhhhhhhhhh!!!!!!!!!!!!!!!!</tspan></text>
            </g>
            <g ref={ligne4Ref} id="Ligne_4" className="svg--isolate">
                <text className="svg--isolate" transform="translate(-910.7 566.8)"><tspan x="0" y="0">aaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne5Ref} id="Ligne_5" className="svg--isolate">
                <text className="svg--primary" transform="translate(-885.4 705.4)"><tspan x="0" y="0">aaaaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne6Ref} id="Ligne_6" className="svg--isolate">
                <text className="svg--isolate" transform="translate(-926.9 844)"><tspan x="0" y="0">aaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
        </svg>
    );
}

AaaaahDesktop.propTypes = {
    containerClasses: PropTypes.string
}

function AaaaahMobile({ containerClasses }) {
    // On définit les références du SVG
    const svgRefMobile = useRef(null);
    const ligne1Ref = useRef(null);
    const ligne2Ref = useRef(null);
    const ligne3Ref = useRef(null);
    const ligne4Ref = useRef(null);
    const ligne5Ref = useRef(null);
    const ligne6Ref = useRef(null);
    const ligne7Ref = useRef(null);
    const ligne8Ref = useRef(null);

    // On initialise le hook de GSAP pour React afin de gérer l'ajout et la suppression des
    // écouteurs de manière automatique
    useGSAP(() => {
        if(!svgRefMobile || !ligne1Ref || !ligne2Ref || !ligne3Ref || !ligne4Ref || !ligne5Ref || !ligne6Ref || !ligne7Ref || !ligne8Ref) return;

        // On liste les lignes à animer dans un tableau
        const lines = [
            { selector: "#Aaaaaah_mobile #Ligne_1", x: 250, endTrigger: ligne1Ref.current },
            { selector: "#Aaaaaah_mobile #Ligne_2", x: -250, endTrigger: ligne2Ref.current },
            { selector: "#Aaaaaah_mobile #Ligne_3", x: 250, endTrigger: ligne3Ref.current },
            { selector: "#Aaaaaah_mobile #Ligne_4", x: -250, endTrigger: ligne4Ref.current },
            { selector: "#Aaaaaah_mobile #Ligne_5", x: 250, endTrigger: ligne3Ref.current },
            { selector: "#Aaaaaah_mobile #Ligne_6", x: -250, endTrigger: ligne4Ref.current },
            { selector: "#Aaaaaah_mobile #Ligne_7", x: 250, endTrigger: ligne7Ref.current },
            { selector: "#Aaaaaah_mobile #Ligne_8", x: -250, endTrigger: ligne8Ref.current }
        ]

        // On définit l'animation ligne par ligne
        lines.forEach((line) => {
            gsap.to(line.selector, {
                x: line.x,
                ease: 'none',
                scrollTrigger: {
                    trigger: line.selector,
                    start: "top bottom",
                    endTrigger: line.endTrigger,
                    end: "bottom top",
                    scrub: true
                },
            });
        })
    }, { scope: svgRefMobile });

    return (
        <svg role="img" ref={svgRefMobile} id="Aaaaaah_mobile" className={containerClasses} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 2200 1133.6">
            <title>Aaaaaaaaaaaaaahhh</title>
            <g ref={ligne1Ref} id="Ligne_1" className="svg--isolate">
                <text className="svg--primary" transform="translate(-1038.1 151)"><tspan x="0" y="0">aaaaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne2Ref} id="Ligne_2" className="svg--isolate">
                <text className="svg--isolate" transform="translate(-1083.3 289.6)"><tspan x="0" y="0">aaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne3Ref} id="Ligne_3" className="svg--isolate">
                <text className="svg--primary" transform="translate(-834.2 428.2)"><tspan x="0" y="0">aaaaaaaaaaaaaahhhhhhhhhhhhh!!!!!!!!!!!!!!!!</tspan></text>
            </g>
            <g ref={ligne4Ref} id="Ligne_4" className="svg--isolate">
                <text className="svg--isolate" transform="translate(-910.7 566.8)"><tspan x="0" y="0">aaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne5Ref} id="Ligne_5" className="svg--isolate">
                <text className="svg--primary" transform="translate(-885.4 705.4)"><tspan x="0" y="0">aaaaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne6Ref} id="Ligne_6" className="svg--isolate">
                <text className="svg--isolate" transform="translate(-926.9 844)"><tspan x="0" y="0">aaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne7Ref} id="Ligne_7" className="svg--isolate">
                <text className="svg--primary" transform="translate(-1005.4 982.6)"><tspan x="0" y="0">aaaaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhh</tspan></text>
            </g>
            <g ref={ligne8Ref} id="Ligne_8" className="svg--isolate">
                <text className="svg--isolate" transform="translate(-816.9 1121.2)"><tspan x="0" y="0">aaaaaaaaaaaaaaaahhhhhhhhhhhhhhhhhhh</tspan></text>
            </g>
        </svg>
    );
}

AaaaahMobile.propTypes = {
    containerClasses: PropTypes.string
}
